module.exports = __webpack_public_path__ + "media/img/ms-icon-310x310-25377c76f870f5b4d201723b6ab06581.png";